import React, { useState } from 'react'
import { guestName, stayDatesLabel } from './fieldStays'
import { CheckIcon, LockIcon, NoResultIcon, SuitcaseIcon } from './FieldIcons'
import { FLOW_TYPES, BackButton, SectionTitle, ListGroup, ListRow, Notice, PrimaryButton, BottomBar } from './FieldUI'
import { colors } from './fieldTheme'

// « Pas le bon séjour ? » : séjours voisins sur l'emplacement (décision 16).
// Pas d'écran Waze dans le canvas : contenu de P3, mis au style « Liste native » de W5.

export default function FieldStayNeighbors({ type, pitch, proposed, neighbors, clients, now, isDone, onConfirm, onStayNumber, proposedTitle, backLabel, onBack })
{
	const [selected, setSelected] = useState(proposed || null)
	const short = FLOW_TYPES[type].short
	const doneLabel = type === 'departure' ? 'Sortie déjà faite' : 'Entrée déjà faite'

	const row = (stay) => {
		const done = isDone(stay, type)
		const isSelected = !!selected && selected.stay_number === stay.stay_number
		const name = guestName(clients[stay.client_number])
		let trailing = null
		if (isSelected)
			trailing = <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, color: colors.primary, fontSize: 15, fontWeight: 700, flex: 'none' }}><CheckIcon />Choisi</span>
		else if (done)
			trailing = <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, color: '#5B6577', fontSize: 15, fontWeight: 700, flex: 'none' }}><LockIcon />{doneLabel}</span>
		return (
			<ListRow
				key={stay.stay_number}
				title={name || 'Séjour n° ' + stay.stay_number}
				titleSize={19}
				minHeight={64}
				subtitle={stayDatesLabel(stay, now) + '\nSéjour n° ' + stay.stay_number}
				disabled={done && !isSelected}
				selected={isSelected}
				trailing={trailing}
				onClick={() => setSelected(stay)}
			/>
		)
	}

	const count = (list, word) => (list.length === 1 ? '1 séjour ' + word : list.length + ' séjours ' + word + 's')
	const empty = !proposed && neighbors.previous.length === 0 && neighbors.next.length === 0
	const selectedName = selected ? (guestName(clients[selected.client_number]) || 'séjour n° ' + selected.stay_number) : ''

	return (
		<div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
			<BackButton label={backLabel} onClick={onBack} />
			<div style={{ padding: '24px 20px 0', display: 'flex', flexDirection: 'column', gap: 4 }}>
				<span style={{ fontSize: 15, fontWeight: 700, color: colors.textSecondary }}>{pitch.location + ' · ' + short}</span>
				<h1 style={{ fontSize: 28, lineHeight: 1.2, fontWeight: 800, color: colors.text }}>{'Séjours sur ' + pitch.location}</h1>
				{!empty && (
					<p style={{ fontSize: 17, fontWeight: 500, color: colors.textSecondary }}>
						{type === 'departure' ? 'Touchez le séjour dont vous faites la sortie.' : 'Touchez le séjour dont vous faites l\'entrée.'}
					</p>
				)}
			</div>

			{empty && <Notice icon={<NoResultIcon />} title={'Aucun séjour enregistré sur ' + pitch.location} hint="Saisissez le numéro du séjour s'il est rattaché à un autre emplacement." />}

			{proposed && (
				<React.Fragment>
					<SectionTitle>{proposedTitle}</SectionTitle>
					<ListGroup indent={20}>{row(proposed)}</ListGroup>
				</React.Fragment>
			)}
			{neighbors.previous.length > 0 && (
				<React.Fragment>
					<SectionTitle>{count(neighbors.previous, 'précédent')}</SectionTitle>
					<ListGroup indent={20}>{neighbors.previous.map(row)}</ListGroup>
				</React.Fragment>
			)}
			{neighbors.next.length > 0 && (
				<React.Fragment>
					<SectionTitle>{count(neighbors.next, 'suivant')}</SectionTitle>
					<ListGroup indent={20}>{neighbors.next.map(row)}</ListGroup>
				</React.Fragment>
			)}

			<div style={{ marginTop: 24 }}>
				<ListGroup indent={20}>
					<ListRow title="Saisir un numéro de séjour" titleSize={19} minHeight={64} onClick={onStayNumber} trailing={<span style={{ color: colors.primary, display: 'flex' }}><SuitcaseIcon /></span>} />
				</ListGroup>
			</div>

			{!empty && (
				<BottomBar>
					<PrimaryButton disabled={!selected} onClick={() => onConfirm(selected)}>
						{selected ? 'Confirmer : ' + selectedName : 'Choisissez un séjour'}
					</PrimaryButton>
				</BottomBar>
			)}
			{empty && <div style={{ height: 32 }} />}
		</div>
	)
}
